// extracted by mini-css-extract-plugin
export default {"home":"Home_home__uEIM2","title":"Home_title__qAdt+","songs":"Home_songs__sgde1","link":"Home_link__2B1SO"};